import React from 'react';
const firstPhrase = `บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด (“บริษัท”) ใช้คุกกี้บนเว็บไซต์ www.hytexts.com เพื่อมอบประสบการณ์การใช้งานที่ดีแก่ผู้ใช้ รวมถึงใช้เพื่อ
พัฒนาและปรับปรุงการให้บริการให้ตรงกับความต้องการของผู้ใช้งานมากยิ่งขึ้น`;
const thirdPhrase =
   'เรียนทุกท่านที่เข้ามาใช้งานเว็บไซต์ หากไม่ใช้คุกกี้ระหว่างที่ท่านเข้าใช้งาน บริการหรือหน้าต่างๆบนเว็บไซต์อาจทำงานได้ไม่เต็มประสิทธิภาพตามที่ท่านต้องการ เช่น ท่านจะไม่สามารถใช้บริการการเลือกสินค้าได้และบริษัทจะไม่สามารถแจ้งเตือนท่านเกี่ยวกับสินค้าที่ท่านอาจสนใจตามประสบการณ์การเลือกซื้อสินค้าที่ผ่านมาของท่านได้ ';
const fourthPhrase =
   'หากต้องการลบคุกกี้ในคอมพิวเตอร์ ท่านใช้คำสั่งโดยกดที่คำว่า “ช่วยเหลือ” ในรายการเบราว์เซอร์ของท่าน';

const CookiePolicy = () => {
   return (
      <div className='side cookie-policy'>
         <p className='side-title-c'>นโยบายการใช้คุกกี้</p>
         <div className='phrase'>
            <p className='plain'>{firstPhrase}</p>
            <p className='plain'>
               1. คุกกี้ (Cookies) คือไฟล์ข้อความขนาดเล็กที่ถูกบันทึกลงในอุปกรณ์ของท่านเมื่อเข้าชมเว็บไซต์
               เพื่อช่วยให้เว็บไซต์สามารถจดจำการใช้งานของท่าน เช่น การเข้าสู่ระบบ การตั้งค่าต่าง ๆ
               หรือสินค้าที่อยู่ในตะกร้า
            </p>
            <p className='plain'>
               2. ประโยชน์ของคุกกี้ คุกกี้ช่วยให้เว็บไซต์ของเราทำงานได้อย่างมีประสิทธิภาพ และปรับปรุงการทำงานของเว็บไซต์
               เพื่อให้สามารถบริหารจัดการสิ่งต่าง ๆ ที่คุณสนใจได้ ดังนั้นบริษัทมีความจำเป็นต้องใช้คุกกี้แต่ละประเภค
               ดังนี้
            </p>

            <p className='plain-no-margin-bottom'>คุกกี้เพื่อการทำงาน (Functional Cookies)</p>
            <ul>
               <li>จดจำการเลือกสินค้า</li>
               <li>จดจำการซื้อสินค้า</li>
            </ul>

            <p className='plain-no-margin-bottom'>คุกกี้ที่จำเป็น (Strictly Necessary Cookies)</p>
            <ul>
               <li>
                  คุกกี้จะบันทึกการตั้งค่าแรกของเว็บไซต์ไว้ด้วยเช่นกัน
                  ซึ่งจะช่วยให้ลูกค้าได้รับค่าที่ตั้งไว้เดิมแต่แรกทุกครั้งที่ใช้งาน หากคุกกี้ถูกลบการตั้งค่า
                  ทุกอย่างจะกลับไปที่ค่าเริ่มต้น
               </li>
            </ul>

            <p className='plain-no-margin-bottom'>คุกกี้ปฏิบัติการ (Performance Cookies)</p>
            <ul>
               <li>ปรับปรุงการทำงานของเว็บไซต์</li>
               <li>ปรับปรุงการให้บริการแก่ผู้ใช้งาน</li>
            </ul>

            <p className='plain-no-margin-bottom'>คุกกี้เป้าหมาย (Targeting Cookies)</p>
            <ul>
               <li>ให้ท่านแสดงความคิดเห็นต่อข้อมูลที่อยู่บนเว็บไซต์</li>
               <li>สามารถส่งต่อข้อมูลให้แก่เว็บไซต์อื่นๆ เพื่อปรับปรุงโฆษณา ตามความต้องการของเว็บไซต์</li>
            </ul>

            <p className='plain'>
               3. ความปลอดภัยของคุกกี้ <br />
               คุกกี้ไม่ทำให้เกิดอันตรายต่อคอมพิวเตอร์ของคุณวัตถุประสงค์หลักของคุกกี้คือการรวบรวมข้อมูลในรูปแบบไฟล์
               ซึ่งไม่มีหน้าที่อื่นใดนอกเหนือจากน
            </p>

            <p className='plain'>
               4. สิ่งที่คุกกี้ไม่ได้รวบรวมมีอะไรบ้าง <br />
               คุกกี้ไม่เก็บรวบรวมข้อมูลเกี่ยวกับข้อมูลรายละเอียดส่วนบุคคลของคุณเช่น หมายเลขโทรศัพท์
               หรือวันเดือนปีเกิดของคุณหากมีการเก็บข้อมูลเพิ่มเติม
               นอกเหนือจากนี้จะต้องได้รับความยินยอมจากลูกค้าก่อนการเก็บข้อมูล
            </p>

            <p className='plain'>
               5. วิธีการปิดการทำงานของคุกกี้ทำอย่างไร <br />
               ลูกค้าสามารถปิดการตั้งค่าการทำงานของคุกกี้ได้โดยเข้าไปที่หน้าการตั้งค่าบราวเซอร์
               และตั้งค่าความเป็นส่วนตัวเพื่อหยุดการรวบรวมข้อมูลทุกอย่างของคุกกี้ในอนาคต
            </p>

            <p className='plain'>
               เรียนทุกท่านที่เข้ามาใช้งานเว็บไซต์ หากไม่ใช้คุกกี้ระหว่างที่ท่านเข้าใช้งาน
               บริการหรือหน้าต่างๆบนเว็บไซต์อาจทำงานได้ไม่เต็มประสิทธิภาพ ตามที่ท่านต้องการ เช่น
               ท่านจะไม่สามารถใช้บริการการเลือกสินค้าได้และบริษัทจะไม่สามารถแจ้งเตือนท่านเกี่ยวกับสินค้าที่ท่านอาจสนใจตามประสบการณ์
               การเลือกซื้อสินค้าที่ผ่านมาของท่านได้
            </p>

            <p className='plain'>
               นอกจากนี้ ยังสามารถศึกษาเกี่ยวกับคุกกี้เพิ่มเติม รวมถึงวิธีการลบและควบคุมคุกกี้ได้ที่
               www.aboutcookies.org หรือโดยกดที่คำว่า “ช่วยเหลือ” ในหน้ารายการเบราว์เซอร์ของท่าน
            </p>

            <h1 className='side-title-c' style={{ textAlign: 'left' }}>
               รายละเอียดการติดต่อเรา
            </h1>
            <p className='plain'>
               หากท่านมีความประสงค์ที่จะใช้สิทธิของท่านที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่าน <br />
               หรือหากท่านมีข้อสงสัยเกี่ยวกับข้อมูลส่วนบุคคลของท่านภายใต้นโยบายความเป็นส่วนตัวฉบับนี้ <br />
               โปรดติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเรา ที่
            </p>
            <ol>
               <li>
                  บริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จำกัด (Hytexts) <br />3 อาคารพร้อมพันธุ์ 3 ชั้น 7 ห้อง 701-702 ซอย
                  ลาดพร้าว 3 แขวงจอมพล เขตจตุจักร กรุงเทพมหานคร 10900 <br />
                  โทร: 02-024-6690 (จันทร์-ศุกร์ 9.00-18.00 น. เว้นวันหยุดราชการ) <br />
                  อีเมล: contact@hytexts.com
               </li>
               <li>
                  เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล ฝ่ายคุ้มครองข้อมูลส่วนบุคคล เซ็นทรัล กรุ๊ป เลขที่ 22 ซอยสมคิด
                  ถนนเพลินจิต แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330 <br /> อีเมล:{' '}
                  <a href='dpo@central.co.th'>dpo@central.co.th</a>
               </li>
            </ol>
         </div>
      </div>
   );
};
export default CookiePolicy;
